import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import common from './assets/locales/en/common.json';
import account from './assets/locales/en/account.json';
import menu from './assets/locales/en/menu.json';
import item from './assets/locales/en/item.json';
import modifier from './assets/locales/en/modifier.json';
import onBoarding from './assets/locales/en/onboarding.json';
import site from './assets/locales/en/site.json';

export const resources = {
    en: {
        common,
        account,
        menu,
        item,
        modifier,
        onBoarding,
        site,
    },
};

i18n.use(initReactI18next).init({
    lng: 'en',
    ns: ['common', 'account'],
    defaultNS: 'common',
    resources,
});

export default i18n;
